import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { fetchVehicleInfoByVrn } from 'domains/order/Order.requests';
import { getIsVrnSearchLoading, getOrderClaimForm, setOrderClaimForm } from 'domains/order/Order.store';
import { getTextWithMandatoryFlag, isHidden } from 'pages/MyOrdersPage/OrderClaims/claimForm.utils';
import { makeKey, RULES_DATA } from 'pages/MyOrdersPage/OrderClaims/claimFormRulesData';
import { FlexRow } from 'pages/MyOrdersPage/OrderClaims/OrderClaims.styled';
import { DatePicker, Flex, CleverInput, Spin, Text } from 'UI';
import { getMomentDate } from 'utils/date/dateConverter';

const VehicleSection = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const claimForm = useSelector(getOrderClaimForm);
  const isVrnSearchLoading = useSelector(getIsVrnSearchLoading);
  const rulesData =
    RULES_DATA[makeKey({ formType: claimForm.formType, reason: claimForm.reason, option: claimForm.option })];

  if (isHidden(rulesData?.vehicle)) {
    return null;
  }

  const vehicle = claimForm.vehicle ?? { vrn: '' };

  const updateVehicle = (patch: Partial<typeof vehicle>) =>
    dispatch(setOrderClaimForm({ ...claimForm, vehicle: { ...vehicle, ...patch } }));

  const handleVrnBlur = (vrn: string) => {
    updateVehicle({ vrn });
    fetchVehicleInfoByVrn(dispatch, vrn);
  };

  const vrnSuffix = isVrnSearchLoading ? <Spin size={'small'} /> : undefined;

  return (
    <>
      <FlexRow gap={30}>
        <Flex direction={'column'} maxWidth={200}>
          <Text type="base" noWrap>
            {getTextWithMandatoryFlag(t('order.claim.vehicle.vrn', 'VRN'), true)}
          </Text>
          <CleverInput
            name={'claim_vehicle_vrn'}
            bordered
            value={vehicle.vrn}
            onBlur={handleVrnBlur}
            suffix={vrnSuffix}
          />
        </Flex>
      </FlexRow>
      <FlexRow gap={30}>
        <Flex direction={'column'} maxWidth={200}>
          <Text type="base" noWrap>
            {t('order.claim.vehicle.registration_date', 'Registration date')}
          </Text>
          <DatePicker bordered disabled value={getMomentDate(vehicle.registrationDate) ?? null} />
        </Flex>
        <Flex direction={'column'} maxWidth={200}>
          <Text type="base" noWrap>
            {t('order.claim.vehicle.brand', 'Brand')}
          </Text>
          <CleverInput name={'claim_vehicle_brand'} bordered disabled value={vehicle.brand} />
        </Flex>
        <Flex direction={'column'} maxWidth={200}>
          <Text type="base" noWrap>
            {t('order.claim.vehicle.model', 'Model')}
          </Text>
          <CleverInput name={'claim_vehicle_model'} bordered disabled value={vehicle.model} />
        </Flex>
        <Flex direction={'column'} maxWidth={200}>
          <Text type="base" noWrap>
            {t('order.claim.vehicle.energy', 'Energy')}
          </Text>
          <CleverInput name={'claim_vehicle_energy'} bordered disabled value={vehicle.energy} />
        </Flex>
        <Flex direction={'column'} maxWidth={200}>
          <Text type="base" noWrap>
            {t('order.claim.vehicle.engine_code', 'Engine code')}
          </Text>
          <CleverInput name={'claim_vehicle_engine_code'} bordered disabled value={vehicle.engineCode} />
        </Flex>
      </FlexRow>
    </>
  );
};

export default VehicleSection;
